import React, { Component } from 'react';
import ChevronUp from 'sushiweb/Icons/all/ChevronUp';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { withRouter } from "react-router";
import ChevronDown from 'sushiweb/Icons/all/ChevronDown';
import { clone, findIndex, propEq } from 'ramda';


import './SummaryPage.scss';
import SummaryTable from './SummaryTable';
import { ASSET_SUMMARY_TABLE } from './../../../operations/tableModal';
import { getOrderAssets, getAssetsType } from './../../../actions/assetsActions';
import { ASSET_PROTO, TRANSACTION_TYPE } from './../../../operations/constants';

class AssetSummary extends Component {
    constructor() {
        super();
        this.state = {
            showDetails: false
        }
    }

    componentDidMount = () => {
        const orderId = this.props.match.params.id;
        this.props.actions.getOrderAssets(orderId);
        this.props.actions.getAssetsType();
    }

    showHideDetails = () => {
        const { showDetails } = this.state;
        this.setState({ showDetails: !showDetails });
    }

    mapAssets = () => {
        const { uploadedAssets, assetTypes } = this.props;
        let mappedAssets = [];
        uploadedAssets.forEach(asset => {
            const assetName = assetTypes.filter(type => type.name === asset.assetName) || [];
            const mappedIndex = findIndex(propEq('assetName', assetName.length ? assetName[0].displayName : ""))(mappedAssets);
            if (mappedIndex >= 0) {
                if (asset.transactionType === TRANSACTION_TYPE.CREDIT) {
                    mappedAssets[mappedIndex].deliveredQuantity = asset.quantity;
                } else if (asset.transactionType === TRANSACTION_TYPE.DEBIT) {
                    mappedAssets[mappedIndex].recievedQuantity = asset.quantity;
                }
            } else {
                let newMapping = clone(ASSET_PROTO);
                newMapping.assetName = assetName.length ? assetName[0].displayName : "";
                newMapping.deliveredQuantity = 0;
                newMapping.recievedQuantity = 0;
                if (asset.transactionType === TRANSACTION_TYPE.CREDIT) {
                    newMapping.deliveredQuantity = asset.quantity;
                } else if (asset.transactionType === TRANSACTION_TYPE.DEBIT) {
                    newMapping.recievedQuantity = asset.quantity;
                }
                mappedAssets.push(newMapping);
            }
        });
        return mappedAssets;
    }

    render() {
        const { showDetails } = this.state;
        const { uploadedAssets = [] } = this.props;
        const mappedAssets = uploadedAssets.length > 0 ? this.mapAssets() : [];
        const delivered = clone(mappedAssets).reduce((acc, value) => {
            return acc + value.deliveredQuantity;
        }, 0);
        const recieved = clone(mappedAssets).reduce((acc, value) => {
            return acc + value.recievedQuantity;
        }, 0);
        return (
            <div className="container fs-14">
                <div className="pd-bottom-20 pd-top-20 fs-16 w-600">Assets</div>
                <div>
                    <span className="mr-2">Types Added</span>
                    <span className="w-600">{mappedAssets.length}</span>
                </div>
                <div>
                    <span className="mr-2">Delivered</span>
                    <span className="w-600">{delivered}</span>
                </div>
                <div>
                    <span className="mr-2">Recieved</span>
                    <span className="w-600">{recieved}</span>
                </div>
                {showDetails && <SummaryTable
                    className="mt-2"
                    modal={ASSET_SUMMARY_TABLE}
                    content={mappedAssets}
                />}
                <div className="green-text flex pd-top-20 w-600" onClick={() => this.showHideDetails()}>
                    {!showDetails ? "View Details" : "Hide Details"}
                    {!showDetails ? <ChevronDown className="ml-1 icon-medium icon-color-green" /> : <ChevronUp className="ml-1 icon-medium icon-color-green" />}
                </div>
                <div className="light-line "></div>
            </div>
        )
    }
}

const actions = { getOrderAssets, getAssetsType }
export default withRouter(connect(
    state => ({
        uploadedAssets: state.assets.orderAssets || [],
        assetTypes: state.assets.assetsType || []
    }),
    dispatch => ({
        actions: bindActionCreators(actions, dispatch),
    }),
)(AssetSummary));